<script lang="ts">
  import type { Waypoint } from "../../support/connections";
  import { constrain } from "../../support/geometry";
  import { fade } from "svelte/transition";

  export let waypoint: Waypoint;
  export let zoom = 1;

  $: size = 40;
  $: scale = constrain(1 / zoom, 0.7, 2);
  $: x = waypoint.x - size * 0.5;
  $: y = waypoint.y - size;
  $: shadowX = 6;
  $: shadowY = 4;
</script>

<g
  in:fade={{ duration: 500 }}
  out:fade={{ duration: 200 }}
  style="--x: {waypoint.x}px; --y: {waypoint.y}px; --scale: {scale}"
>
  <ellipse class="Shadow" cx={waypoint.x} cy={waypoint.y - 2} rx={shadowX} ry={shadowY} />

  <use class="Icon" xlink:href="#icon-map-event" {x} {y} width={size} height={size} />
</g>

<style>
  @keyframes animate-pool {
    0% {
      transform: scale(0.7);
    }

    100% {
      transform: scale(1);
      opacity: 0.2;
    }
  }

  @keyframes animate-float {
    0% {
      transform: translate(0, 0);
    }

    100% {
      transform: translate(0, -3px) scale(1.1, 1.1);
    }
  }

  g {
    transform: scale(var(--scale));
    transform-origin: var(--x) var(--y);
  }

  .Shadow {
    animation: 1s animate-pool;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    fill: var(--pin-color, #ffff00);
    fill-opacity: 0.4;
    transform-origin: var(--x) calc(var(--y) - 2px);
  }

  .Icon {
    animation: 1s animate-float;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(0.17, 0.85, 0.57, 1.07);
    fill: var(--pin-color, #ffff00);
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
    transform-origin: var(--x) var(--y);
  }
</style>
